export default __webpack_public_path__ + "static/media/m1-logo-public.3092c556.svg";